import {Collection} from 'vue-mc'
import {JobsModel} from '../models/jobsModel'
import Vue from "vue";

export default class JobsCollection extends Collection {

    model() {
        return JobsModel;
    }

    // Default attributes
    defaults() {
        return {
	        publicApiURL: Vue.prototype.$publicApiURL,
            orderBy: 'ref_no',
	        role_id: 0
        }
    }

    // Route configuration
    routes() {
        return {
            fetch: 'jobs/get',
            fetchLatest: 'jobs/getLastByClientId',
	        getJobsInformation: 'jobs/charts/getJobsInformation',
	        getJobsByType: 'jobs/charts/type',
	        getDhsJobs: 'sessional/job/list',
	        getDhsJobsByDate: 'sessional/getsessiondate',
	        getDhsInvoiceRecords: 'role/{role_id}/aggregate/invoiced',
	        getJobsForrelief: 'sessional/getrelief',
	        getJobsForunfilled: 'sessional/getunfilled'
        }
    }

	setRoleID(role_id) {
		this.getAttributes().methodTypes = 'getDhsInvoiceRecords';
		this.getAttributes().role_id = role_id;

		let route = this.getAttributes().publicApiURL + this.getRoute(this.getAttributes().methodTypes);
		let params = this.getRouteParameters();

		return this.getURL(route, params);
	}

	getJobRecordsFor(type) {
		this.getAttributes().methodTypes = 'getJobsFor' + type;

		let route = this.getAttributes().publicApiURL + this.getRoute(this.getAttributes().methodTypes);
		let params = this.getRouteParameters();

		return this.getURL(route, params);
	}
}



// WEBPACK FOOTER //
// ./src/collections/jobsCollection.js